import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../Basic/Buttons/Button';
import { TYPE_BUTTONS } from '../../../constans';
import { useNavigate } from 'react-router-dom';
import UserApi from '../../../API/user/user-api';
import { removeUser } from '../../../actions/user';

const AuthButton = ({ ...props }) => {
  let navigate = useNavigate();
  const user = useSelector(state => state.user);
  const dispatch = useDispatch();

  const { auth } = user;


  const logoutClick = async () => {
    await UserApi.logout({}).then(r => dispatch(removeUser()))
    navigate('login');
  }
  return (
    auth && (
      <Button type={TYPE_BUTTONS.WHITE} onClick={auth ? logoutClick : () => navigate('login')}>
        {auth ? 'Выйти' : 'Войти'}
      </Button>
    )
  );
};

export default AuthButton;

